// 投稿の中で指定道具を使っているかチェックし、置換する関数
import { getFirestore, collection, getDocs, updateDoc, doc } from 'firebase/firestore';
import { getFirebaseApp } from './firebaseConfig';

const db = getFirestore(getFirebaseApp());

export async function findPostsUsingTool(toolId) {
  const postsCol = collection(db, 'posts');
  const snapshot = await getDocs(postsCol);
  return snapshot.docs
    .filter(doc => (doc.data().toolIds || []).includes(toolId))
    .map(doc => ({ id: doc.id, ...doc.data() }));
}

export async function replaceToolInPosts(oldToolId, newToolId) {
  const posts = await findPostsUsingTool(oldToolId);
  for (const post of posts) {
    const newToolIds = post.toolIds.map(id => id === oldToolId ? newToolId : id);
    await updateDoc(doc(db, 'posts', post.id), { toolIds: newToolIds });
  }
}
